import toast, {Toaster} from "react-hot-toast";
import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Accordion, Button} from "react-bootstrap";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Bar, Line } from "react-chartjs-2";

import {LineChart, LineChart3, LineChart4, LineChart5} from "../partials/charts/default/Charts";


// import { Bar } from "react-chartjs-2"; // ✅ for using Bar charts
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement, // <-- this is the correct chart element you need
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import {Block, Row, Col, PreviewAltCard, TooltipComponent, Icon} from "../Component";
import {DepositBarChart} from "../partials/charts/invest/InvestChart";
import {totalDeposit} from "../partials/charts/invest/InvestData";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {
    ActiveUserBarChart,
    AudienceLineChart2,
    AudienceLineChart3,
    TCDoughnut
} from "../partials/charts/analytics/AnalyticsCharts";
import traffic from "../partials/analytics/traffic-channel/Traffic";
import {max} from "moment/moment";
import ReactTooltip from "react-tooltip";

// ✅ Only register the chart elements, NOT Bar component
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,   // <-- make sure to add this!
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


const AdvanceDashboard = () => {

    let client = null;

    const [selectedMetric, setSelectedMetric] = useState("Cash Deposit");

    const [chartData, setChartData] = useState({ labels: [], datasets: [] });
    const [chartData2, setChartData2] = useState({ labels: [], datasets: [] });
    const [chartData3, setChartData3] = useState({ labels: [], datasets: [] });
    const [allService,setService] = useState([]);
    const [selectedServices,setSelectedServices] = useState(null);
    const [serviceWaitTimeAvg,setServiceWaitTimeAvg] = useState(0);
    const [serviceUsers,setServiceUsers] = useState(0);
    const [spent,setSpent] = useState(0);
    const [serviceE,setServiceE] = useState(0);
    const [waitE,setWaitE] = useState(0);
    const [visitorData, setVisitorData] = useState([]);
    const [spentHourly, setSpentHourly] = useState([]);
    const [dailyVisitorData, setDailyVisitorData] = useState([]);
    const [dailyVisitorWaitTimeData, setDailyVisitorWaitTimeData] = useState([]);
    const [dailyVisitorServiceTimeData, setDailyVisitorServiceTimeData] = useState([]);
    const [dailyPeakHour,setDailyPeakHour] = useState([]);
    const [dailyMostUsedChanel,setDailyMostUsedChanel] = useState([]);
    const [dailyWaitTimeException,setDailyWaitTimeException] = useState([]);
    const [dailyServiceTimeException,setDailyServiceTimeException] = useState([]);
    const [chartDataServiceException, setChartDataServiceException] = useState({ labels: [], datasets: [] });
    const [chartServiceException,setChartServiceException] = useState([]);
    const [maxServiceExceptionTime,setMaxServiceExceptionTime] = useState("");
    const  [serviceByHourly,setServiceByHourly] = useState([]);
    const  [waitExceptionHourly,setWaitExceptionHourly] = useState([]);
    const  [serviceExceptionHourly,setServiceExceptionHourly] = useState([]);
    const [functionData,setFunctionData] = useState([]);
    const [functionData1,setFunctionData1] = useState([]);
    const [serviceDataLoaded, setServiceDataLoaded] = useState(false);
    const [selectedServiceName, setSelectedServiceName] = useState("");
    const [selectedFunctionName, setSelectedFunctionName] = useState("");



    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 1);
    const [selectDay2,setSelectDay2] = useState(sevenDaysAgo)




    const serviceFunctionMap = [
        { label: "Issued Ticket", value: 1 },
        { label: "Served Ticket", value: 2 },
        { label: "Waiting Exception", value: 3 },
        { label: "Service Exception", value: 4 },
        { label: "Avg Spent Time", value: 5 },
    ];

    const [selectFunction, setFunction] = useState(serviceFunctionMap[0].value);



    // const data1 = {
    //     labels: test,
    //     datasets: [
    //         {
    //             label: selectedMetric,
    //             data: sampleData[selectedMetric],
    //             fill: true,
    //             borderColor: 'rgba(102, 16, 242, 0.8)',
    //             backgroundColor: 'rgba(102, 16, 242, 0.1)',
    //             tension: 0.3,
    //         }
    //     ]
    // };
    //
    // const options1 = {
    //     responsive: true,
    //     plugins: {
    //         legend: { display: false },
    //     },
    //     scales: {
    //         y: {
    //             beginAtZero: true,
    //             ticks: {
    //                 callback: value => value.toLocaleString()
    //             }
    //         }
    //     }
    // };
    let configs = JSON.parse(localStorage.getItem("configuration_data"));
    let userDetails = JSON.parse(localStorage.getItem("user_details"));
    const location = useLocation();
    const [sticky, setSticky] = useState(false);
    const [selectedBranchName, setSelectedBranchName] = useState(null);

    const userBranchId = userDetails['bid'];
    const userBranchName = userDetails['branchName'];
    const userBranchLevel = userDetails['branchLevel'];
    const userBranchQType = userDetails['queueTypeId'];
    const refChartValue = useRef(0)
    //mqtt
    const [messageArrived, setMessageArrived] = useState(false)
    const [messageData, setMessageData] = useState('')
    const [messageIncLobby, setMessageIncLobby] = useState('')
    const [messageInc1000, setMessageInc1000] = useState('')
    const [messageInc1001, setMessageInc1001] = useState('')
    const [messageInc1002, setMessageInc1002] = useState('')
    const [messageInc1010, setMessageInc1010] = useState('')
    const [messageInc1011, setMessageInc1011] = useState('')
    const [messageInc2000, setMessageInc2000] = useState('')
    const [messageInc2001, setMessageInc2001] = useState('')
    const [messageInc3000, setMessageInc3000] = useState('')
    const [messageInc3001, setmessageInc3001] = useState('')
    const [messageInc9999, setMessageInc9999] = useState('')
    const [messageInc9998, setMessageInc9998] = useState('')
    const [messageInc4000, setMessageInc4000] = useState('')
    const [allDataLoaded, setAllDataLoaded] = useState(false);
    const [country, setCountry] = useState({});
    const [selectedCountry, setselectedCountry] = useState(null)
    const [province, setprovince] = useState({});
    const [provinces, setProvinces] = useState([]);
    const [selectedProvince, setselectedProvince] = useState(null);
    const [district, setdistrict] = useState({});
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setselectedDistrict] = useState(null);
    const [userBranch, setuserBranch] = useState({});
    const [branches, setBranches] = useState([]);
    const [selectedUserBranch, setSelectedUserBranch] = useState(null)
    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [selectedBranchLevel, setSelectedBranchLevel] = useState(null);
    const [selectedBranchQueueType, setSelectedBranchQueueType] = useState(null);
    const [lastDayVisitors,setLastDayVisitors] = useState(0);
    const [lastTwoDayVisitors,setLastTwoDayVisitors] = useState(0);
    const [lastThreeDayVisitors,setLastThreeDayVisitors] = useState(0);
    const [lastMothFourthDayVisitors,setLastFourthDayVisitors] = useState(0);
    const [lastWeekVisitors,setLastWeekVisitors] = useState(0);
    const [allDayVisitors,setAllDayVisitors] = useState(0);
    const [lastMonthVisitors,setLastMonthVisitors] = useState(0);
    const [serviceException, setServiceException] = useState([]);
    const [waitingException, setWaitingException] = useState([]);
    const [spentTime,setSpentTime] = useState([]);


    const [lastDayVisitorsWaitTime,setLastDayVisitorsWaitTime] = useState(0);
    const [lastTwoDayVisitorsWaitTime,setLastTwoDayVisitorsWaitTime] = useState(0);
    const [lastThreeDayVisitorsWaitTime,setLastThreeDayVisitorsWaitTime] = useState(0);
    const [lastDayFourthVisitorsWaitTime,setLastFourthDayVisitorsWaitTime] = useState(0);
    const [lastWeekVisitorsWaitTime,setLastWeekVisitorsWaitTime] = useState(0);
    const [allDayVisitorsWaitTime,setAllDayVisitorsWaitTime] = useState(0);
    const [lastMonthVisitorsWaitTime,setLastMonthVisitorsWaitTime] = useState(0);



    const [lastDayVisitorsServiceTime,setLastDayVisitorServiceTime] = useState(0);
    const [lastTwoDayVisitorsServiceTime,setLastTwoDayVisitorsServiceTime] = useState(0);
    const [lastThreeDayVisitorsServiceTime,setLastThreeDayVisitorsServiceTime] = useState(0);
    const [lastDayFourthVisitorsServiceTime,setLastFourthDayVisitorsServiceTime] = useState(0);
    const [lastWeekVisitorsServiceTime,setLastWeekVisitorsServiceTime] = useState(0);
    const [allDayVisitorsServiceTime,setAllDayVisitorsServiceTime] = useState(0);
    const [lastMonthVisitorsServiceTime,setLastMonthVisitorsServiceTime] = useState(0);

    const history = useNavigate();
    const [branchSqeuenceData, setBranchSqeuenceData] = useState({});
    const renderFunction = () => {
        if (location.state !== null) {
            setSelectedBranchId(location.state.selectedBranchId);
            setSelectedBranchName(location.state.selectedBranchName);
            setSelectedBranchLevel(location.state.selectedBranchLevel);
            setSelectedBranchQueueType(location.state.selectedBranchQueueType);
        } else {
            setSelectedBranchId(userBranchId);
            setSelectedBranchName(userBranchName);
            setSelectedBranchLevel(userBranchLevel);
            setSelectedBranchQueueType(userBranchQType);
        }
    }
    const [selectedDate, setSelectedDate] = useState(new Date());


    const setMessages = (messageData) => {
        if (messageData === '1') {
            setMessageIncLobby(new Date().toString())
        } else if (messageData === '1000') {
            setMessageInc1000(new Date().toString());
        } else if (messageData === '1001') {
            setMessageInc1001(new Date().toString());
        } else if (messageData === '1002') {
            setMessageInc1002(new Date().toString());
        } else if (messageData === '9999') {
            setMessageInc9999(new Date().toString());
        } else if (messageData === '2000') {
            setMessageInc2000(new Date().toString());
        } else if (messageData === '2001') {
            setMessageInc2001(new Date().toString());
        } else if (messageData === '3000') {
            setMessageInc3000(new Date().toString());
        } else if (messageData === '3001') {
            setmessageInc3001(new Date().toString());
        } else if (messageData === '1010') {
            setMessageInc1010(new Date().toString());
        } else if (messageData === '1011') {
            setMessageInc1011(new Date().toString());
        } else if (messageData === '9998') {
            setMessageInc9998(new Date().toString());
        }
    }
    const navigateToBranchTables = (selectedBranchId, selectedBranchName, selectedBranchLevel, selectedBranchQueueType) => {
        history('/branch-tables-page', {
            state: {
                selectedBranchId: selectedBranchId,
                selectedBranchName: selectedBranchName,
                selectedBranchLevel: selectedBranchLevel,
                selectedBranchQueueType: selectedBranchQueueType
            }
        });
    }
    const executeFunctions = (messageData) => {
        if (selectedBranchId !== null) {

            getBranchSequence();
            if (messageData === null || messageData === '') {



            } else {

                console.info("message data: ", messageData)
                setMessages(messageData);

                // if (messageData === "1000" ||
                //     messageData === '1001') {
                //     noSkillTicketsDetails();
                // }

                if (messageData === '1' ||
                    messageData === '1000' ||
                    messageData === '1001' ||
                    messageData === '1002' ||
                    messageData === '2001' ||
                    messageData === '3000' ||
                    messageData === '3001' ||
                    messageData === '9998' ||
                    messageData === '9999') {

                }

                if (messageData === '1000' ||
                    messageData === '1001') {

                }

                if (messageData === '1001') {

                }

                // if (messageData === '1000' ||
                //     messageData === '1001') {
                //     getWaitingTicketDetails();
                // }

                // if (messageData === '1000' ||
                //     messageData === '1001' ||
                //     messageData === '2000' ||
                //     messageData === '2001' ||
                //     messageData === '3001') {
                //     getTicketDetailsByBranch();
                // }

                if (messageData === '1001') {

                }

                if (messageData === '1000' ||
                    messageData === '1001' ||
                    messageData === '2000' ||
                    messageData === '2001' ||
                    messageData === '3000' ||
                    messageData === '3001') {

                }

                if (messageData === '1001') {

                }

                if (messageData === '1001' ||
                    messageData === '1010' ||
                    messageData === '1011' ||
                    messageData === '9999') {

                }
            }
        }
    }

    const  formatDate = (date) => {
        return date.toISOString().split("T")[0]; // e.g. "2025-04-24"
    };

    const getVisitors = () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllVisitors/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            const [lastMonth, lastTwoMonths, lastThreeMonths, lastFourthMonth, lastWeek,all,lastMonths] = res.data;

            // Set the values to state variables
            setLastDayVisitors(lastMonth);
            setLastTwoDayVisitors(lastTwoMonths);
            setLastThreeDayVisitors(lastThreeMonths);
            setLastFourthDayVisitors(lastFourthMonth);
            setLastWeekVisitors(lastWeek);
            setAllDayVisitors(all);
            setLastMonthVisitors(lastMonths);
        }).catch((err) => {
            console.error(err);
        });
    };
    const getVisitorsWaitTime = () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllVisitorsWaitTime/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            const [lastMonth, lastTwoMonths, lastThreeMonths, lastFourthMonth, lastWeek,all,months] = res.data;

            // Set the values to state variables
            setLastDayVisitorsWaitTime(lastMonth);
            setLastTwoDayVisitorsWaitTime(lastTwoMonths);
            setLastThreeDayVisitorsWaitTime(lastThreeMonths);
            setLastFourthDayVisitorsWaitTime(lastFourthMonth);
            setLastWeekVisitorsWaitTime(lastWeek);
            setAllDayVisitorsWaitTime(all);
            setLastMonthVisitorsWaitTime(months)
        }).catch((err) => {
            console.error(err);
        });
    };
    const getServiceWaitTimeAndVisitors = async () => {
        const formattedDate = formatDate(selectedDate);

        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors/${selectedBranchId}/${formattedDate}/${selectedServices}`,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            const [awaitTime, users, spent, waitE, serviceE] = res.data;

            setServiceUsers(users);
            setServiceWaitTimeAvg(awaitTime);
            setSpent(spent);
            setWaitE(waitE);
            setServiceE(serviceE);
        } catch (err) {
            console.error("Error in getServiceWaitTimeAndVisitors:", err);
        }
    };
    const getServiceWaitTimeException = async () => {
        const formattedDate = formatDate(selectedDate);

        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getDaily-chart-details-waitTime-exception/${selectedBranchId}/${formattedDate}`,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            setDailyWaitTimeException(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("Error in getServiceWaitTimeException:", err);
        }
    };


    const getFunctionData = () => {


        const formattedDate = formatDate(selectDay2);

        // Clear previous data
        setFunctionData([]);
        setFunctionData1([]);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getFunctionData/${selectedBranchId}/${formattedDate}/${selectedServices}/${selectFunction}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            setFunctionData(res.data);




            if (selectFunction === 1) {

                setFunctionData1(visitorData);

            } else if (selectFunction === 2) {
                setFunctionData1(serviceByHourly);
            } else if (selectFunction === 3) {
                setFunctionData1(waitExceptionHourly);
            } else if (selectFunction === 4) {
                setFunctionData1(serviceExceptionHourly);
            } else if (selectFunction === 5) {
                setFunctionData1(spentHourly);
            }

            console.log(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getServiceServiceTimeException = () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getDaily-chart-details-serviceTime-exception/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            const data = res.data;
            setDailyServiceTimeException(data);
            // maxServiceTime(data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getServiceWaitTimeAndVisitorsOverview = async () => {
        const formattedDate = formatDate(selectedDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview/${selectedBranchId}/${formattedDate}/${selectedServices}/1`,
                { headers: { Authorization: token } }
            );
            setVisitorData(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceWaitTimeAndVisitorsOverview error:", err);
        }
    };

    const getServiceWaitTimeAndVisitorsOverviewSpentTime = async () => {
        const formattedDate = formatDate(selectedDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview/${selectedBranchId}/${formattedDate}/${selectedServices}/5`,
                { headers: { Authorization: token } }
            );
            setSpentHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceWaitTimeAndVisitorsOverviewSpentTime error:", err);
        }
    };

    const getServiceTimeByServices = async () => {
        const formattedDate = formatDate(selectedDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview/${selectedBranchId}/${formattedDate}/${selectedServices}/2`,
                { headers: { Authorization: token } }
            );
            setServiceByHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceTimeByServices error:", err);
        }
    };

    const getWaitTimeExceptionHourly = async () => {
        const formattedDate = formatDate(selectedDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview/${selectedBranchId}/${formattedDate}/${selectedServices}/3`,
                { headers: { Authorization: token } }
            );
            setWaitExceptionHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getWaitTimeExceptionHourly error:", err);
        }
    };

    const getServiceTimeExceptionHourly = async () => {
        const formattedDate = formatDate(selectedDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview/${selectedBranchId}/${formattedDate}/${selectedServices}/4`,
                { headers: { Authorization: token } }
            );
            setServiceExceptionHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceTimeExceptionHourly error:", err);
        }
    };

    const getPeakHours= () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getDaily-chart-details-peak-hours/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyPeakHour(res.data);
            console.log(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getMostUsetChanel= () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getDaily-chart-details-most-use/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyMostUsedChanel(res.data);

        }).catch((err) => {
            console.error(err);
        });
    };
    const getVisitorsDaily = () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getDaily-chart-details/${selectedBranchId}/${formattedDate}/${1}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyVisitorData(res.data);
            console.log(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getDailyServiceException = () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getDailyServiceException/${selectedBranchId}/${formattedDate}/${1}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyVisitorData(res.data);
            console.log(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };
    const getDailyWaitTime= () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard//getDaily-chart-details/${selectedBranchId}/${formattedDate}/${2}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyVisitorWaitTimeData(res.data);
            console.log(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };
    const getDailyServiceTimeAvg = () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard//getDaily-chart-details/${selectedBranchId}/${formattedDate}/${3}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyVisitorServiceTimeData(res.data);
            console.log(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };
    const getVisitorsServiceTime = () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllVisitorsServiceTime/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            const [lastMonth, lastTwoMonths, lastThreeMonths, lastFourthMonth, lastWeek,all,month] = res.data;

            // Set the values to state variables
            setLastDayVisitorServiceTime(lastMonth);
            setLastTwoDayVisitorsServiceTime(lastTwoMonths);
            setLastThreeDayVisitorsServiceTime(lastThreeMonths);
            setLastFourthDayVisitorsServiceTime(lastFourthMonth);
            setLastWeekVisitorsServiceTime(lastWeek);
            setAllDayVisitorsServiceTime(all);
            setLastMonthVisitorsServiceTime(month)

        }).catch((err) => {
            console.error(err);
        });
    };

    const getServices = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllService/${selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            let services = res.data;
            if (services.length > 0) {
                // Add "All" option at the beginning
                services = [{ id: -1, name: "All Services" }, ...services];
                setService(services);
                setSelectedServices(-1); // Auto-select "All"
            } else {
                setService([]);
                setSelectedServices(null);
            }
        }).catch((err) => {
            console.error(err);
        });
    };


    const getBranchSequence = () => {
        // userDetails['userType']
        axios({
            method: 'GET',
            url: `${baseUrl}/branch/get-sequence/branch/${selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getBranchSequence success');
            let data = res.data.data;
            setBranchSqeuenceData(data);

            if (data.countryId !== undefined) {
                setselectedCountry(data.countryId);
                getCountry(data.countryId);
                getProvinces(data.countryId, data.provinceId);
            }

            if (data.provinceId !== undefined) {
                setselectedProvince(data.provinceId);
                getDistricts(data.provinceId, data.districtId);
            }

            if (data.districtId !== undefined) {
                setselectedDistrict(data.districtId)
                getBranches(data.districtId);
            }

            if (data.branchId !== undefined) {
                setSelectedUserBranch(data.branchId);
            }

        }).catch((error) => {
            console.log('getBranchSequence error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getCountry = (country) => {
        axios({
            method: 'GET',
            url: `${baseUrl}/branch/get-branch/${country}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getCountry success');
            let data = res.data.data;
            setCountry(data);

        }).catch((error) => {
            console.log('getCountry error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getProvinces = (country, province) => {

        let url = ``;

        if (userDetails['branchLevel'] === 1) {

            url = `${baseUrl}/branch/get-all/parent-branch/${country}`;

        } else if (userDetails['branchLevel'] === 3 || userDetails['branchLevel'] === 4) {

            url = `${baseUrl}/branch/get-branch/${province}`

        } else {

            url = `${baseUrl}/branch/get-branch/${userDetails['bid']}`;

        }

        axios({
            method: 'GET',
            url: url,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getProvinces success');
            let data = res.data.data;
            console.log("province data: ", data);
            if (userDetails['branchLevel'] === 1) {
                setProvinces(data);
            } else {
                setprovince(data);
            }

        }).catch((error) => {
            console.log('getProvinces error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getDistricts = (province, district) => {
        let url = ``;

        if (userDetails['branchLevel'] === 1 || userDetails['branchLevel'] === 2) {

            url = `${baseUrl}/branch/get-all/parent-branch/${province}`;

        } else if (userDetails['branchLevel'] === 4) {

            url = `${baseUrl}/branch/get-branch/${district}`

        } else {

            url = `${baseUrl}/branch/get-branch/${userDetails['bid']}`;

        }

        axios({
            method: 'GET',
            url: url,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getDistricts success');
            let data = res.data.data;

            if (userDetails['branchLevel'] === 1
                || userDetails['branchLevel'] === 2) {
                setDistricts(data);
            } else {
                setdistrict(data);
            }

        }).catch((error) => {
            console.log('getDistricts error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getBranches = (district) => {
        let url = ``;

        if (userDetails['branchLevel'] === 4) {
            url = `${baseUrl}/branch/get-branch/${userDetails['bid']}`;
        } else {
            url = `${baseUrl}/branch/get-all/parent-branch/${district}`;
        }

        axios({
            method: 'GET',
            url: url,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getBranches success');
            let data = res.data.data;

            if (userDetails['branchLevel'] === 4) {
                setuserBranch(data);
            } else {
                if (data !== null) {
                    setBranches(data);
                }
            }

        }).catch((error) => {
            console.log('getBranches error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    // const maxServiceTime = (data) => {
    //     if (!Array.isArray(data) || data.length === 0) {
    //         setMaxServiceExceptionTime("");
    //         return;
    //     }
    //
    //     let maxEntry = data.reduce((max, current) => current[1] > max[1] ? current : max);
    //
    //     const hour = maxEntry[0]; // e.g., 8 means 8.00
    //     const value = maxEntry[1];
    //
    //     setMaxServiceExceptionTime(`${hour - 1}:00-${hour}:00 (${value})`);
    // };


    const getServiceException= () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllServiceException/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {


            setServiceException(res.data);

        }).catch((err) => {
            console.error(err);
        });
    }

        const getWaitingException= () => {
            const formattedDate = formatDate(selectedDate);

            axios({
                method: 'GET',
                url: `${baseUrl}/dashboard/getAllWaitException/${selectedBranchId}/${formattedDate}`,
                headers: {
                    Authorization: token
                }
            }).then((res) => {


                setWaitingException(res.data);

            }).catch((err) => {
                console.error(err);
            });
        }
    const getSpentTime= () => {
        const formattedDate = formatDate(selectedDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllSpentTime/${selectedBranchId}/${formattedDate}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {


            setSpentTime(res.data);

        }).catch((err) => {
            console.error(err);
        });
    }


            useEffect(() => {
        renderFunction();

    }, [AdvanceDashboard])

    useEffect(() => {
        if (baseUrl.length > 0 && token.length > 0) {
            executeFunctions('');
        }
    }, [baseUrl, token, selectedBranchId, refChartValue])

    useEffect(() => {
        const today = new Date();
        setSelectedDate(today);
    }, []);

    const getLastFourDays = () => {
        const days = [];
        let date = new Date();

        if (selectedDate != null) {
            date = new Date(selectedDate);
        }

        for (let i = 4; i >= 0; i--) {
            const d = new Date(date);
            d.setDate(date.getDate() - i);
            days.push(d.toLocaleDateString('default', { weekday: 'short', day: 'numeric', month: 'short' }));

        }

        return days;
    };


    const data = {
        labels: getLastFourDays(),  // dynamically generated month labels
        datasets: [
            {
                label: "Visitors",
                data: [
                    lastMothFourthDayVisitors,
                    lastThreeDayVisitors,
                    lastTwoDayVisitors,
                    lastDayVisitors,
                    allDayVisitors
                ], // match order with labels: [Month -3, -2, -1, current]
                backgroundColor: "#0d6efd",
            },
        ],
    };
    const timeToSeconds = (timeStr) => {
        if (!timeStr || typeof timeStr !== 'string') return 0;
        const [hours, minutes, seconds] = timeStr.split(":").map(Number);
        return (hours * 3600) + (minutes * 60) + seconds;
    };

    const dataWaitTime = {
        labels: getLastFourDays(),
        datasets: [
            {
                label: "Avg Wait Time (seconds)",
                data: [
                    timeToSeconds(lastDayFourthVisitorsWaitTime),
                    timeToSeconds(lastThreeDayVisitorsWaitTime),
                    timeToSeconds(lastTwoDayVisitorsWaitTime),
                    timeToSeconds(lastDayVisitorsWaitTime),
                    timeToSeconds(allDayVisitorsWaitTime)
                ],
                backgroundColor: "#0d6efd",
            },
        ],
    };

    const dataServiceTime = {
        labels: getLastFourDays(),
        datasets: [
            {
                label: "Avg Wait Time (seconds)",
                data: [
                    timeToSeconds(lastDayFourthVisitorsServiceTime),
                    timeToSeconds(lastThreeDayVisitorsServiceTime),
                    timeToSeconds(lastTwoDayVisitorsServiceTime),
                    timeToSeconds(lastDayVisitorsServiceTime),
                    timeToSeconds(allDayVisitorsServiceTime)
                ],
                backgroundColor: "#0d6efd",
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    useEffect(() => {
        const today = new Date();
        // const formatted = today.toISOString().split("T")[0];
        setSelectedDate(today);
    }, []);

    useEffect(() => {
        if (selectedDate && selectedBranchId != null) {
            getVisitors();
            getVisitorsWaitTime();
            getVisitorsServiceTime()

            getDailyServiceTimeAvg()
            getDailyWaitTime()
            getVisitorsDaily()
            getPeakHours();
            getMostUsetChanel();
            getServiceWaitTimeException();
            getServiceServiceTimeException();
            getServiceException();
            getWaitingException();
            getSpentTime();
        }
    }, [selectedDate,selectedBranchId]);

    const [trafficStats, setTrafficStats] = useState([]);

    useEffect(() => {
        if (dailyMostUsedChanel && dailyMostUsedChanel.length > 0) {
            const total = dailyMostUsedChanel.reduce((sum, [_, count]) => sum + count, 0);

            const formatted = dailyMostUsedChanel.map(([label, count]) => ({
                label,
                count,
                percentage: ((count / total) * 100).toFixed(2),
            }));

            setTrafficStats(formatted);
        }
    }, [dailyMostUsedChanel]);


    useEffect(() => {
        if (dailyVisitorData.length > 0) {

            const reversedData = dailyVisitorData.reverse();

            const labels = reversedData.map(item => item[0]); // Extract dates
            const data = reversedData.map(item => item[1]); // Extract counts

            setChartData({
                labels: labels, // Updated labels in reversed order
                datasets: [
                    {
                        label: "Visitors",
                        data: data, // Updated data in reversed order
                        backgroundColor: "#0d6efd",
                    },
                ],
            });
        }
    }, [selectedDate, selectedBranchId, dailyVisitorData]);



    useEffect(() => {
        if (dailyVisitorWaitTimeData.length > 0) {
            // Reverse the data so that the latest date is first
            const reversedData = dailyVisitorWaitTimeData.reverse();

            const labels = reversedData.map(item => item[0]); // Extract dates

            // Convert the time strings to seconds
            const data = reversedData.map(item => {
                const timeParts = item[1].split(':'); // Split the time (HH:MM:SS)
                const hoursInSeconds = parseInt(timeParts[0]) * 3600; // Convert hours to seconds
                const minutesInSeconds = parseInt(timeParts[1]) * 60; // Convert minutes to seconds
                const seconds = parseInt(timeParts[2]); // Seconds
                return hoursInSeconds + minutesInSeconds + seconds; // Total seconds
            });

            setChartData2({
                labels: [...labels], // cloned labels
                datasets: [
                    {
                        label: "(seconds)",
                        data: [...data], // cloned data
                        backgroundColor: "#0d6efd",
                    },
                ],
            });
        }
    }, [selectedDate, selectedBranchId, dailyVisitorWaitTimeData]);

    useEffect(() => {
        if (dailyVisitorServiceTimeData.length > 0) {
            // Reverse the data so that the latest date is first
            const reversedData = dailyVisitorServiceTimeData.reverse();

            const labels = reversedData.map(item => item[0]); // Extract dates

            // Convert the time strings to seconds
            const data = reversedData.map(item => {
                const timeParts = item[1].split(':'); // Split the time (HH:MM:SS)
                const hoursInSeconds = parseInt(timeParts[0]) * 3600; // Convert hours to seconds
                const minutesInSeconds = parseInt(timeParts[1]) * 60; // Convert minutes to seconds
                const seconds = parseInt(timeParts[2]); // Seconds
                return hoursInSeconds + minutesInSeconds + seconds; // Total seconds
            });

            setChartData3({
                labels: [...labels], // cloned labels
                datasets: [
                    {
                        label: "(seconds)",
                        data: [...data], // cloned data
                        backgroundColor: "#0d6efd",
                    },
                ],
            });
        }
    }, [selectedDate, selectedBranchId, dailyVisitorServiceTimeData]);
    useEffect(() => {

        if(selectedBranchId != null) {
            getServices()
        }
    }, [selectedBranchId]);

    useEffect(() => {
        const loadServiceData = async () => {
            if (selectedServices != null && selectedBranchId != null) {
                setServiceDataLoaded(false); // Reset before loading

                try {
                    await Promise.all([
                        getServiceWaitTimeAndVisitors(),
                        getServiceWaitTimeAndVisitorsOverview(),
                        getServiceWaitTimeAndVisitorsOverviewSpentTime(),
                        getServiceTimeByServices(),
                        getWaitTimeExceptionHourly(),
                        getServiceTimeExceptionHourly()
                    ]);
                } catch (error) {
                    console.error("Error loading service data:", error);
                }

                setServiceDataLoaded(true); // Mark as complete
            }
        };



        loadServiceData();
        const foundService = allService.find(service => service.id === selectedServices);
        setSelectedServiceName(foundService?.name || "Unknown Service");



    }, [selectedBranchId, selectedDate, selectedServices]);

    // Second useEffect: Only run when first is fully done
    useEffect(() => {
        if (selectedServices != null && serviceDataLoaded && selectedBranchId !=null) {
            getFunctionData();

        }
        const foundFunction = serviceFunctionMap.find(service => service.value === selectFunction);
        setSelectedFunctionName(foundFunction?.label || "Unknown Function");
    }, [selectedBranchId, selectDay2, selectedServices, selectFunction, selectedDate, serviceDataLoaded]);


    return(
        <>
            <div><Toaster /></div>
            <div className={`${sticky ? "block-header block-header-padding sticky" : "block-header block-header-padding"}`}>
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1>Advance Branch Dashboard</h1>

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item active" aria-current="page">{selectedBranchName}</li>
                            </ol>
                        </nav>

                    </div>


                </div>
            </div>


            <div className="container-fluid branch-dashboard">

                <>
                    {userDetails['branchLevel'] !== 4 ? (
                        <div className="row clearfix">
                            <div className="col-md-12 col-sm-8 p-l-5 p-r-5 mb-4">
                                <div className="card">
                                    <div className="body">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 p-l-5 p-r-5">
                                                <Accordion className="accordion" id="accordion">
                                                    <div>
                                                        <div className="card-header " id="headingOne">
                                                            <h5 className="mb-0">
                                                                <Accordion.Toggle as={Button} variant="link"
                                                                                  eventKey="0"
                                                                                  className={selectedBranchLevel === 4 ? 'acc-color-branch'
                                                                                      : selectedBranchLevel === 3 ? 'acc-color-district'
                                                                                          : selectedBranchLevel === 2 ? 'acc-color-province'
                                                                                              : 'acc-color-country'}
                                                                >
                                                                    {branchSqeuenceData.name}
                                                                    <div className="float-right"><i
                                                                        className="fa fa-chevron-circle-down"></i></div>
                                                                </Accordion.Toggle>
                                                            </h5>
                                                        </div>
                                                        <Accordion.Collapse eventKey="0" className="collapse">
                                                            <div className="body">
                                                                <div className='row clearfix'>
                                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                                        <div className="card">
                                                                            <div
                                                                                className='taskboard b-cyan progress_task'>
                                                                                <h6 className="font300 mb-3">Country
                                                                                </h6>
                                                                                <div className="dd"
                                                                                     data-plugin="nestable">
                                                                                    {userDetails['branchLevel'] === 1 ? (
                                                                                        <div
                                                                                            className={`dd-handle align-items-center ${selectedCountry === country.id ? 'active' : ''}`}
                                                                                            // key={country.id}
                                                                                            onClick={() => {
                                                                                                setselectedCountry(country.id)
                                                                                                setselectedProvince(null)
                                                                                                setselectedDistrict(null)
                                                                                                setSelectedUserBranch(null)
                                                                                                setDistricts([])
                                                                                                setBranches([])

                                                                                            }}

                                                                                        >
                                                                                            <div
                                                                                                className='d-flex justify-content-between'>
                                                                                                <div>{country.name}</div>
                                                                                                <div
                                                                                                    className={selectedBranchId === country.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                        : 'btn btn-prymary select-btn'}
                                                                                                    onClick={() => {
                                                                                                        setSelectedBranchId(country.id)
                                                                                                        setSelectedBranchName(country.name)
                                                                                                        setSelectedBranchLevel(country.level)
                                                                                                    }}
                                                                                                >
                                                                                                    <i className="fa fa-external-link float-left"></i>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div
                                                                                            className='dd-handle align-items-center'
                                                                                            style={{cursor: 'default'}}
                                                                                        >
                                                                                            <div
                                                                                                className='d-flex justify-content-between'>
                                                                                                <div>{country.name}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                                        <div className="card">
                                                                            <div
                                                                                className='taskboard b-cyan progress_task'>
                                                                                <h6 className="font300 mb-3">Province
                                                                                </h6>
                                                                                <div className="dd"
                                                                                     data-plugin="nestable">
                                                                                    {provinces !== null ? (
                                                                                        <>
                                                                                            {userDetails['branchLevel'] === 1 ? (
                                                                                                <>
                                                                                                    {provinces.map((data, i) =>
                                                                                                        <div
                                                                                                            className={`dd-handle align-items-center ${selectedProvince === data.id ? 'active' : ''}`}
                                                                                                            key={i}
                                                                                                            onClick={() => {
                                                                                                                setselectedProvince(data.id)
                                                                                                                setselectedDistrict(null)
                                                                                                                setSelectedUserBranch(null)
                                                                                                                setBranches([])
                                                                                                            }}
                                                                                                        >
                                                                                                            <div
                                                                                                                className='d-flex justify-content-between'>
                                                                                                                <div>{data.name}</div>
                                                                                                                <div
                                                                                                                    className={selectedBranchId === data.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                                        : 'btn btn-prymary select-btn'}
                                                                                                                    onClick={() => {
                                                                                                                        setSelectedBranchId(data.id)
                                                                                                                        setSelectedBranchName(data.name)
                                                                                                                        setSelectedBranchLevel(data.level)
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i className="fa fa-external-link float-left"></i>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </>
                                                                                            ) : userDetails['branchLevel'] === 2 ? (
                                                                                                <div
                                                                                                    className={`dd-handle align-items-center ${selectedProvince === province.id ? 'active' : ''}`}
                                                                                                    onClick={() => {
                                                                                                        setselectedProvince(province.id)
                                                                                                        setselectedDistrict(null)
                                                                                                        setSelectedUserBranch(null)
                                                                                                        setBranches([])
                                                                                                    }}
                                                                                                >
                                                                                                    <div
                                                                                                        className='d-flex justify-content-between'>
                                                                                                        <div>{province.name}</div>
                                                                                                        <div
                                                                                                            className={selectedBranchId === province.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                                : 'btn btn-prymary select-btn'}
                                                                                                            onClick={() => {
                                                                                                                setSelectedBranchId(province.id)
                                                                                                                setSelectedBranchName(province.name)
                                                                                                                setSelectedBranchLevel(province.level)
                                                                                                            }}
                                                                                                        >
                                                                                                            <i className="fa fa-external-link float-left"></i>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div
                                                                                                    className='dd-handle align-items-center'
                                                                                                    style={{cursor: 'default'}}
                                                                                                >
                                                                                                    <div
                                                                                                        className='d-flex justify-content-between'>
                                                                                                        <div>{province.name}</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        <div
                                                                                            className={`dd-handle align-items-center`}>
                                                                                            <div
                                                                                                className='d-flex justify-content-between'>
                                                                                                <div> No provices
                                                                                                    yet...
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                                        <div className="card">
                                                                            <div
                                                                                className='taskboard b-cyan progress_task'>
                                                                                <h6 className="font300 mb-3">District
                                                                                </h6>
                                                                                <div className="dd"
                                                                                     data-plugin="nestable">
                                                                                    {userDetails['branchLevel'] === 1 || userDetails['branchLevel'] === 2 ? (
                                                                                        <>
                                                                                            {districts !== null ? (
                                                                                                <>
                                                                                                    {districts.length > 0 ? (
                                                                                                        <>
                                                                                                            {districts.map((data, i) =>
                                                                                                                <div
                                                                                                                    className={`dd-handle align-items-center ${selectedDistrict === data.id ? 'active' : ''}`}
                                                                                                                    key={i}
                                                                                                                    onClick={() => {
                                                                                                                        setselectedDistrict(data.id);
                                                                                                                        setSelectedUserBranch(null);
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <div
                                                                                                                        className='d-flex justify-content-between'>
                                                                                                                        <div>{data.name}</div>
                                                                                                                        <div
                                                                                                                            className={selectedBranchId === data.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                                                : 'btn btn-prymary select-btn'}
                                                                                                                            onClick={() => {
                                                                                                                                setSelectedBranchId(data.id)
                                                                                                                                setSelectedBranchName(data.name)
                                                                                                                                setSelectedBranchLevel(data.level)
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className="fa fa-external-link float-left"></i>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </>
                                                                                                    ) : (<div
                                                                                                        className={`dd-handle align-items-center`}>
                                                                                                        <div
                                                                                                            className='d-flex justify-content-between'>
                                                                                                            <div> Select
                                                                                                                Provice
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>)}
                                                                                                </>
                                                                                            ) : (<div
                                                                                                className={`dd-handle align-items-center`}>
                                                                                                <div
                                                                                                    className='d-flex justify-content-between'>
                                                                                                    <div> No districts
                                                                                                        yet...
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>)}
                                                                                        </>
                                                                                    ) : userDetails['branchLevel'] === 3 ? (
                                                                                        <div
                                                                                            className={`dd-handle align-items-center ${selectedDistrict === district.id ? 'active' : ''}`}

                                                                                            onClick={() => {
                                                                                                setselectedDistrict(district.id);
                                                                                                setSelectedUserBranch(null);
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                className='d-flex justify-content-between'>
                                                                                                <div>{district.name}</div>
                                                                                                <div
                                                                                                    className={selectedBranchId === district.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                        : 'btn btn-prymary select-btn'}
                                                                                                    onClick={() => {
                                                                                                        setSelectedBranchId(district.id)
                                                                                                        setSelectedBranchName(district.name)
                                                                                                        setSelectedBranchLevel(district.level)
                                                                                                    }}
                                                                                                >
                                                                                                    <i className="fa fa-external-link float-left"></i>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (<div
                                                                                        className='dd-handle align-items-center'
                                                                                        style={{cursor: 'default'}}
                                                                                    >
                                                                                        <div
                                                                                            className='d-flex justify-content-between'>
                                                                                            <div>{district.name}</div>
                                                                                        </div>
                                                                                    </div>)}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                                        <div className="card">
                                                                            <div
                                                                                className='taskboard b-cyan progress_task'>
                                                                                <h6 className="font300 mb-3">Branch
                                                                                </h6>
                                                                                <div className="dd"
                                                                                     data-plugin="nestable">
                                                                                    {userDetails['branchLevel'] === 1 || userDetails['branchLevel'] === 2 || userDetails['branchLevel'] === 3 ? (
                                                                                        <>
                                                                                            {branches !== null ? (
                                                                                                <>
                                                                                                    {branches.length > 0 ? (
                                                                                                        <>
                                                                                                            {branches.map((data, i) =>
                                                                                                                <div
                                                                                                                    className={`dd-handle align-items-center ${selectedUserBranch === data.id ? 'active' : ''}`}
                                                                                                                    key={i}
                                                                                                                    onClick={() => {
                                                                                                                        setSelectedUserBranch(data.id)
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <div
                                                                                                                        className='d-flex justify-content-between'>
                                                                                                                        <div>{data.name}</div>
                                                                                                                        <div
                                                                                                                            className={selectedBranchId === data.id ? 'btn btn-prymary select-btn external-link-active' : 'btn btn-prymary select-btn'}
                                                                                                                            onClick={() => {
                                                                                                                                setSelectedBranchId(data.id)
                                                                                                                                setSelectedBranchName(data.name)
                                                                                                                                setSelectedBranchLevel(data.level)
                                                                                                                                setSelectedBranchQueueType(data.branchQueueType)
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className="fa fa-external-link float-left"></i>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <div
                                                                                                            className={`dd-handle align-items-center`}>
                                                                                                            <div
                                                                                                                className='d-flex justify-content-between'>
                                                                                                                <div> Select
                                                                                                                    District
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </>
                                                                                            ) : (
                                                                                                <div
                                                                                                    className={`dd-handle align-items-center`}>
                                                                                                    <div
                                                                                                        className='d-flex justify-content-between'>
                                                                                                        <div> No
                                                                                                            branches
                                                                                                            yet...
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    ) : userDetails['branchLevel'] === 4 ? (
                                                                                        <div
                                                                                            className={`dd-handle align-items-center ${selectedUserBranch === userBranch.id ? 'active' : ''}`}
                                                                                            onClick={() => {
                                                                                                setSelectedUserBranch(userBranch.id)
                                                                                                setSelectedBranchId(userBranch.id)
                                                                                                setSelectedBranchName(userBranch.name)
                                                                                                setSelectedBranchLevel(userBranch.level)
                                                                                                setSelectedBranchQueueType(userBranch.branchQueueType)
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                className='d-flex justify-content-between'>
                                                                                                <div>{userBranch.name}</div>
                                                                                                <div
                                                                                                    className={selectedBranchId === userBranch.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                        : 'btn btn-prymary select-btn'}>
                                                                                                    <i className="fa fa-external-link float-left"></i>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (<div
                                                                                        className='dd-handle align-items-center'
                                                                                        style={{cursor: 'default'}}
                                                                                    >
                                                                                        <div
                                                                                            className='d-flex justify-content-between'>
                                                                                            <div>{userBranch.name}</div>
                                                                                        </div>
                                                                                    </div>)}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Collapse>
                                                    </div>
                                                </Accordion>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (null)}

                </>
                <div className="mb-3 mr-1 mb-4 col-12 text-right">
                    {/*<button className="btn btn-sm btn-primary"*/}
                    {/*        type="button"*/}
                    {/*        title={`View Branch Table`}*/}
                    {/*        onClick={() => {*/}
                    {/*            executeFunctions('')*/}
                    {/*        }}*/}
                    {/*>Refresh <i className="fa fa-refresh"></i></button>*/}

                    <DatePicker
                        selected={selectedDate}
                        onChange={(date) => {
                            setSelectedDate(date);
                            const oneDayBefore = new Date(date);
                            oneDayBefore.setDate(date.getDate() - 1);
                            setSelectDay2(oneDayBefore);
                        }}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Select a date"
                        maxDate={new Date()}
                        popperPlacement="bottom-end"

                    />
                    <div className={"mt-2"}>Selected Date: {selectedDate?.toDateString()}</div>

                </div>

                <Block>
                    <Row className="g-gs">
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">Total Visitors</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-total-visitors"
                                            text="Total Visitors"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {allDayVisitors.toLocaleString()} <span className="currency currency-usd">Visitors</span>
                  </span>

                                    <span>
  {lastDayVisitors && allDayVisitors > 0 ? (
      <>
          {allDayVisitors >= lastDayVisitors ? (
              <Icon name="arrow-long-up"></Icon>
          ) : (
              <Icon name="arrow-long-down"></Icon>
          )}
          {Math.abs(((allDayVisitors - lastDayVisitors) / lastDayVisitors) * 100).toFixed(2)}%
      </>
  ) : (
      <span className="text-muted"></span>
  )}
</span>
                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">This Month</div>
                                            <span className="amount">
                      {lastMonthVisitors.toLocaleString()} <span className="currency currency-usd"> Visitors</span>
                      </span>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">This Week</div>
                                            <span className="amount">
                       {lastWeekVisitors.toLocaleString()} <span className="currency currency-usd"> Visitors</span>
                      </span>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        <DepositBarChart chartData={chartData}/>
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">AVG Wait Time</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-avg-wait-time"
                                            text="AVG Wait Time"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
            <span className="amount">
  {allDayVisitorsWaitTime ? allDayVisitorsWaitTime : "No data"}
</span>


                                    {lastDayVisitorsWaitTime ? (
                                        (() => {
                                            const lastMonthSeconds = timeToSeconds(allDayVisitorsWaitTime);
                                            const lastDaySeconds = timeToSeconds(lastDayVisitorsWaitTime);

                                            if (lastMonthSeconds === 0 || lastDaySeconds === 0) {
                                                return <span className="text-muted"></span>;
                                            }

                                            const diff = lastMonthSeconds - lastDaySeconds;
                                            const percentChange = Math.abs((diff / lastDaySeconds) * 100).toFixed(2);
                                            const isUp = diff >= 0;

                                            return (
                                                <span
                                                >
                {isUp ? <Icon name="arrow-long-up"/> : <Icon name="arrow-long-down"/>}
                                                    {percentChange}%
            </span>
                                            );
                                        })()
                                    ) : (
                                        <span className="text-muted"></span>
                                    )}

                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">This Month</div>
                                            <span className="amount">
                      {lastMonthVisitorsWaitTime} <span className="currency currency-usd"> </span>
                      </span>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">This Week</div>
                                            <span className="amount">
                       {lastWeekVisitorsWaitTime} <span className="currency currency-usd"> </span>
                      </span>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        <DepositBarChart chartData={chartData2}/>
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">AVG Service Time</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-avg-Served-time"
                                            text="AVG Served Time"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
            <span className="amount">
  {allDayVisitorsServiceTime ? allDayVisitorsServiceTime : "No data"}
</span>


                                    {lastDayVisitorsServiceTime ? (
                                        (() => {
                                            const lastMonthSeconds = timeToSeconds(allDayVisitorsServiceTime);
                                            const lastDaySeconds = timeToSeconds(lastDayVisitorsServiceTime);

                                            if (lastMonthSeconds === 0 || lastDaySeconds === 0) {
                                                return <span className="text-muted"></span>;
                                            }

                                            const diff = lastMonthSeconds - lastDaySeconds;
                                            const percentChange = Math.abs((diff / lastDaySeconds) * 100).toFixed(2);
                                            const isUp = diff >= 0;

                                            return (
                                                <span
                                                >
                {isUp ? <Icon name="arrow-long-up"/> : <Icon name="arrow-long-down"/>}
                                                    {percentChange}%
            </span>
                                            );
                                        })()
                                    ) : (
                                        <span className="text-muted"></span>
                                    )}

                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">This Month</div>
                                            <span className="amount">
                      {lastMonthVisitorsServiceTime} <span className="currency currency-usd"> </span>
                      </span>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">This Week</div>
                                            <span className="amount">
                       {lastWeekVisitorsServiceTime} <span className="currency currency-usd"> </span>
                      </span>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        <DepositBarChart chartData={chartData3}/>
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>

                    </Row>

                </Block>
                <Block>
                    <Row className="g-gs">
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">Service Exception</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-service-exception"
                                            text="Service Exception"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {serviceException[0]} <span className="currency currency-usd"></span>
                  </span>

                                    <span>
  {serviceException[1] && serviceException[0] > 0 ? (
      <>
          {serviceException[0] >= serviceException[1] ? (
              <Icon name="arrow-long-up"></Icon>
          ) : (
              <Icon name="arrow-long-down"></Icon>
          )}
          {Math.abs(((serviceException[0] - serviceException[1]) / serviceException[1]) * 100).toFixed(2)}%
      </>
  ) : (
      <span className="text-muted"></span>
  )}
</span>
                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">Max Served Time</div>
                                            <span
                                                className="amount"
                                                data-tip={` ${serviceException[4]}<br/>Branch Name:${serviceException[12]}<br/>Ticket Number: ${serviceException[6]}<br/>Counter: ${serviceException[8]}<br/>Teller Name: ${serviceException[10]}`}
                                                data-html={true}
                                            >
      {serviceException[2]} <span className="currency currency-usd"> </span>
    </span>

                                            {/* Add this once at bottom */}
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">Min Service Time</div>
                                            <span
                                                className="amount"
                                                data-tip={` ${serviceException[5]}<br/>Branch Name:${serviceException[13]}<br/>Ticket Number: ${serviceException[7]}<br/>Counter: ${serviceException[9]}<br/>Teller Name: ${serviceException[11]}`}
                                                data-html={true}
                                            >
      {serviceException[3]} <span className="currency currency-usd"> </span>
    </span>

                                            {/* Add this once at bottom */}
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        {/*<DepositBarChart chartData={chartData}/>*/}
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">Waiting Exception</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-waiting-exception"
                                            text="Waiting Exception"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {waitingException[0]} <span className="currency currency-usd"></span>
                  </span>

                                    <span>
  {waitingException[1] && waitingException[0] > 0 ? (
      <>
          {waitingException[0] >= waitingException[1] ? (
              <Icon name="arrow-long-up"></Icon>
          ) : (
              <Icon name="arrow-long-down"></Icon>
          )}
          {Math.abs(((waitingException[0] - waitingException[1]) / waitingException[1]) * 100).toFixed(2)}%
      </>
  ) : (
      <span className="text-muted"></span>
  )}
</span>
                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">Max Waiting Time</div>
                                            <span className="amount"
                                                  data-tip={` ${waitingException[4]}<br/>Branch Name:${waitingException[8]}<br/>Ticket Number: ${waitingException[6]}`}
                                                  data-html={true}

                                            >
                      {waitingException[2]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">Min Waiting Time</div>
                                            <span className="amount"
                                                  data-tip={` ${waitingException[5]}<br/>Branch Name:${waitingException[9]}<br/>Ticket Number: ${waitingException[7]}`}
                                                  data-html={true}

                                            >
                      {waitingException[3]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        {/*<DepositBarChart chartData={chartData}/>*/}
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">AVG Spent Time</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-avg-spent-time"
                                            text="AVG Spent Time"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {spentTime[0]} <span className="currency currency-usd"></span>
                  </span>

                                    <span>
  {spentTime[5] && spentTime[4] > 0 ? (
      <>
          {spentTime[4] >= spentTime[5] ? (
              <Icon name="arrow-long-up"></Icon>
          ) : (
              <Icon name="arrow-long-down"></Icon>
          )}
          {Math.abs(((spentTime[4] - spentTime[5]) / spentTime[5]) * 100).toFixed(2)}%
      </>
  ) : (
      <span className="text-muted"></span>
  )}
</span>
                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">Max Spent Time</div>
                                            <span className="amount"
                                                  data-tip={`${spentTime[6]}`}>
                      {spentTime[2]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">Min Spent Time</div>
                                            <span className="amount"
                                                  data-tip={`${spentTime[7]}`}>
                      {spentTime[3]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        {/*<DepositBarChart chartData={chartData}/>*/}
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>

                    </Row>

                </Block>


                <React.Fragment>
                    <div className="card-title-group align-start gx-3 mb-3 mt-4">
                        <div className="card-title">
                            <h6 className="title">Service Overview ( {serviceUsers} <small>Visitors</small> )</h6>
                            <p>
                                Service Overview
                            </p>
                        </div>
                        <div className="card-tools m-3">
                            <UncontrolledDropdown>
                                <DropdownToggle tag="div" color="transparent">
                                    <a
                                        href="#toggle"
                                        onClick={(ev) => ev.preventDefault()}
                                        className="btn btn-primary btn-dim d-none d-sm-inline-flex"
                                    >
                                        <Icon className="d-none d-sm-inline" name="download-cloud"/>
                                        <span>
                <span className="d-none d-md-inline">
                    {selectedServices
                        ? allService.find(s => s.id === selectedServices)?.name
                        : "Select Service"}

                </span>
            </span>
                                    </a>
                                    <a
                                        href="#toggle"
                                        onClick={(ev) => ev.preventDefault()}
                                        className="btn btn-primary btn-icon btn-dim d-sm-none"
                                    >
                                        <Icon name="download-cloud"/>
                                    </a>
                                </DropdownToggle>

                                <DropdownMenu end>
                                    <ul className="link-list-opt no-bdr">
                                        {allService.map((service) => (
                                            <li key={service.id}>
                                                <DropdownItem
                                                    tag="a"
                                                    href="#dropdownitem"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        setSelectedServices(service.id); // Set selected service id
                                                    }}
                                                >
                                                    <span>{service.name}</span>
                                                </DropdownItem>
                                            </li>
                                        ))}
                                    </ul>
                                </DropdownMenu>
                            </UncontrolledDropdown>

                        </div>
                    </div>
                    {/*                <div className="flex justify-between items-center gap-4">*/}
                    {/*                    /!* Left block: 4 AVG Service Time items *!/*/}
                    {/*                    <div className="flex gap-4">*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Service Time</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceWaitTimeAvg}</span>*/}
                    {/*                        </div>*/}

                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Spent Time</h6>*/}
                    {/*                            <span className="amount font-bold">{spent}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Waiting Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{waitE}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Service Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceE}</span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}

                    {/*                    /!* Right block: Visitors *!/*/}
                    {/*                    <div className="nk-sale-data">*/}
                    {/*<span className="amount sm">*/}
                    {/*  {serviceUsers} <small>Visitors</small>*/}
                    {/*</span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}

                    <div className="analytic-data-group analytic-ov-group g-3">
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">AVG Served Time</div>
                            <div className="amount">{serviceWaitTimeAvg}</div>
                            <div className="change up">
                            </div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">AVG Spent Time</div>
                            <div className="amount">{spent}</div>
                            <div className="change up">
                            </div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">Waiting Exception</div>
                            <div className="amount">{waitE}</div>
                            <div className="change down">
                            </div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">Service Exception</div>
                            <div className="amount">{serviceE}</div>
                            <div className="change down">

                            </div>
                        </div>

                    </div>

                    <div className="nk-sales-ck large pt-4">
                        {visitorData.length > 0 ? (
                            // <LineChart chartData={visitorData}/>
                            <AudienceLineChart3
                                waitTimeData={visitorData}
                                serviceTimeData={serviceByHourly}
                                waitingException={waitExceptionHourly}
                                serviceException={serviceExceptionHourly}
                            />
                        ) : (
                            <div style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>
                                No data available
                            </div>
                        )}
                    </div>

                </React.Fragment>

                <React.Fragment>
                    <div className="card-title-group align-start gx-3 mb-3 mt-4">
                        <div className="card-title">
                            <h6 className="title">Spent Time Overview </h6>
                            <p>
                                Spent Time Overview ( {selectedServiceName} )
                            </p>
                        </div>
                        <div className="card-tools m-3">
                            {/*                <UncontrolledDropdown>*/}
                            {/*                    <DropdownToggle tag="div" color="transparent">*/}
                            {/*                        <a*/}
                            {/*                            href="#toggle"*/}
                            {/*                            onClick={(ev) => ev.preventDefault()}*/}
                            {/*                            className="btn btn-primary btn-dim d-none d-sm-inline-flex"*/}
                            {/*                        >*/}
                            {/*                            <Icon className="d-none d-sm-inline" name="download-cloud"/>*/}
                            {/*                            <span>*/}
                            {/*    <span className="d-none d-md-inline">*/}
                            {/*        {selectedServices*/}
                            {/*            ? allService.find(s => s.id === selectedServices)?.name*/}
                            {/*            : "Select Service"}*/}

                            {/*    </span>*/}
                            {/*</span>*/}
                            {/*                        </a>*/}
                            {/*                        <a*/}
                            {/*                            href="#toggle"*/}
                            {/*                            onClick={(ev) => ev.preventDefault()}*/}
                            {/*                            className="btn btn-primary btn-icon btn-dim d-sm-none"*/}
                            {/*                        >*/}
                            {/*                            <Icon name="download-cloud"/>*/}
                            {/*                        </a>*/}
                            {/*                    </DropdownToggle>*/}

                            {/*                    <DropdownMenu end>*/}
                            {/*                        <ul className="link-list-opt no-bdr">*/}
                            {/*                            {allService.map((service) => (*/}
                            {/*                                <li key={service.id}>*/}
                            {/*                                    <DropdownItem*/}
                            {/*                                        tag="a"*/}
                            {/*                                        href="#dropdownitem"*/}
                            {/*                                        onClick={(ev) => {*/}
                            {/*                                            ev.preventDefault();*/}
                            {/*                                            setSelectedServices(service.id); // Set selected service id*/}
                            {/*                                        }}*/}
                            {/*                                    >*/}
                            {/*                                        <span>{service.name}</span>*/}
                            {/*                                    </DropdownItem>*/}
                            {/*                                </li>*/}
                            {/*                            ))}*/}
                            {/*                        </ul>*/}
                            {/*                    </DropdownMenu>*/}
                            {/*                </UncontrolledDropdown>*/}

                        </div>
                    </div>
                    {/*                <div className="flex justify-between items-center gap-4">*/}
                    {/*                    /!* Left block: 4 AVG Service Time items *!/*/}
                    {/*                    <div className="flex gap-4">*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Service Time</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceWaitTimeAvg}</span>*/}
                    {/*                        </div>*/}

                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Spent Time</h6>*/}
                    {/*                            <span className="amount font-bold">{spent}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Waiting Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{waitE}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Service Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceE}</span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}

                    {/*                    /!* Right block: Visitors *!/*/}
                    {/*                    <div className="nk-sale-data">*/}
                    {/*<span className="amount sm">*/}
                    {/*  {serviceUsers} <small>Visitors</small>*/}
                    {/*</span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}


                    <div className="nk-sales-ck large pt-4">
                        {visitorData.length > 0 ? (
                            <LineChart chartData={spentHourly}/>
                            // <AudienceLineChart3
                            //     waitTimeData={visitorData}
                            //     serviceTimeData={serviceByHourly}
                            //     waitingException={waitExceptionHourly}
                            //     serviceException={serviceExceptionHourly}
                            // />
                        ) : (
                            <div style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>
                                No data available
                            </div>
                        )}
                    </div>

                </React.Fragment>

                <React.Fragment>
                    <div className="card-title-group align-start gx-3 mb-3 mt-4">
                        <div className="card-title">
                            <h6 className="title"> {selectedFunctionName} Overview </h6>
                            <p>
                                {selectedFunctionName} Overview ( {selectedServiceName} )
                            </p>
                        </div>
                        <div className="card-tools m-3 d-flex align-items-start gap-lg-5 flex-wrap">

                            {/* Date Picker */}
                            <div>
                                <DatePicker
                                    selected={selectDay2}
                                    onChange={(date) => setSelectDay2(date)}
                                    dateFormat="yyyy-MM-dd"
                                    placeholderText="Select a date"
                                    maxDate={
                                        selectedDate
                                            ? new Date(new Date(selectedDate).setDate(selectedDate.getDate() - 1))
                                            : null
                                    }
                                    className="form-control"
                                />

                                <div className="mt-2">Selected Date: {selectDay2?.toDateString()}</div>
                            </div>

                            {/* Service Dropdown */}
                            <UncontrolledDropdown>
                                <DropdownToggle tag="div" color="transparent">
                                    <a
                                        href="#toggle"
                                        onClick={(ev) => ev.preventDefault()}
                                        className="btn btn-primary btn-dim d-none d-sm-inline-flex"
                                    >
                                        <Icon className="d-none d-sm-inline" name="download-cloud"/>
                                        <span className="d-none d-md-inline">
        {serviceFunctionMap.find((opt) => opt.value === selectFunction)?.label}
      </span>
                                    </a>
                                    <a
                                        href="#toggle"
                                        onClick={(ev) => ev.preventDefault()}
                                        className="btn btn-primary btn-icon btn-dim d-sm-none"
                                    >
                                        <Icon name="download-cloud"/>
                                    </a>
                                </DropdownToggle>

                                <DropdownMenu end>
                                    <ul className="link-list-opt no-bdr">
                                        {serviceFunctionMap.map((opt) => (
                                            <li key={opt.value}>
                                                <DropdownItem
                                                    tag="a"
                                                    href="#select"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        setFunction(opt.value);
                                                    }}
                                                >
                                                    <span>{opt.label}</span>
                                                </DropdownItem>
                                            </li>
                                        ))}
                                    </ul>
                                </DropdownMenu>
                            </UncontrolledDropdown>


                        </div>

                    </div>
                    {/*                <div className="flex justify-between items-center gap-4">*/}
                    {/*                    /!* Left block: 4 AVG Service Time items *!/*/}
                    {/*                    <div className="flex gap-4">*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Service Time</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceWaitTimeAvg}</span>*/}
                    {/*                        </div>*/}

                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Spent Time</h6>*/}
                    {/*                            <span className="amount font-bold">{spent}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Waiting Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{waitE}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Service Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceE}</span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}

                    {/*                    /!* Right block: Visitors *!/*/}
                    {/*                    <div className="nk-sale-data">*/}
                    {/*<span className="amount sm">*/}
                    {/*  {serviceUsers} <small>Visitors</small>*/}
                    {/*</span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}


                    <div className="nk-sales-ck large pt-1 mb-5">
                        {visitorData.length > 0 || functionData.length > 0 ? (
                            selectFunction === 5 ? (
                                <LineChart5 data1={functionData1}
                                            data2={functionData}
                                            label1={selectedDate?.toDateString()}
                                            label2={selectDay2?.toDateString()}/>
                            ) : (
                                <LineChart3
                                    data1={functionData1}
                                    data2={functionData}
                                    label1={selectedDate?.toDateString()}
                                    label2={selectDay2?.toDateString()}
                                />

                            )
                        ) : (
                            <div style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>
                                No data available
                            </div>
                        )}
                    </div>


                </React.Fragment>


                <div className="row g-gs mt-4">
                    <div className="col-md-6 mt-4">
                        <div className="card h-100">
                            <div className="card-inner">
                                {/* First Fragment - Peak Hours */}

                                <div className="card-title-group align-start pb-3 g-2 mt-4">
                                    <div className="card-title card-title-sm">
                                        <h6 className="title">Peak Hours</h6>
                                        <p>How do your users visited in the time.</p>
                                    </div>
                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help"
                                            direction="left"
                                            id="Tooltip-users"
                                            text="Users of this month"
                                        />
                                    </div>
                                </div>
                                <div className="analytic-au">
                                    <div className="nk-sales-ck large pt-4">
                                        {dailyPeakHour.length > 0 ? (
                                            <ActiveUserBarChart chartData={dailyPeakHour}/>
                                        ) : (
                                            <div style={{textAlign: "center", padding: "2rem", color: "#9eaecf"}}>
                                                No data available
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 d-flex justify-content-center align-items-center">
                        <div className="card h-100">
                            <div className="card-inner">
                                {/* Second Fragment - Traffic Channel */}
                                <div className="card-title-group">
                                    <div className="card-title card-title-sm">
                                        <h6 className="title">Most Used Services</h6>
                                    </div>
                                </div>
                                {/* Conditional rendering based on dailyMostUsedChanel.length */}
                                {dailyMostUsedChanel.length > 0 ? (
                                    <div className="traffic-channel">
                                        <div className="traffic-channel-doughnut-ck">
                                            <TCDoughnut chartData={dailyMostUsedChanel} className="analytics-doughnut"/>
                                        </div>
                                        <div className="traffic-channel-group g-2">
                                            {trafficStats.map((item, index) => {
                                                // Define matching colors for each item
                                                const colors = ["#798bff", "#b8acff", "#ffa9ce", "#f9db7b"];
                                                return (
                                                    <div key={index} className="traffic-channel-data">
                                                        <div className="title">
                                                            <span className="dot dot-lg sq"
                                                                  style={{background: colors[index % colors.length]}}></span>
                                                            <span>{item.label}</span>
                                                        </div>
                                                        <div className="amount">
                                                            {item.count.toLocaleString()}{" "}
                                                            <small>{item.percentage}%</small>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : (
                                    <div className={"mt-lg-5"}
                                         style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>
                                        No data available
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>


                </div>

                {/*<div className="row g-gs mt-4">*/}
                {/*    <div className="col-md-6">*/}
                {/*        <div className="card h-100">*/}
                {/*            <div className="card-inner">*/}
                {/*                /!* First Fragment - Peak Hours *!/*/}

                {/*                <div className="card-title-group align-start pb-3 g-2 mt-4">*/}
                {/*                    <div className="card-title card-title-sm">*/}
                {/*                        <h6 className="title">Exceptions</h6>*/}
                {/*                        <p>How do your users visited in the time.</p>*/}
                {/*                    </div>*/}
                {/*                    <div className="card-tools">*/}
                {/*                        <TooltipComponent*/}
                {/*                            iconClass="card-hint"*/}
                {/*                            icon="help"*/}
                {/*                            direction="left"*/}
                {/*                            id="Tooltip-users"*/}
                {/*                            text="Users of this month"*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*                <div className="analytic-au">*/}
                {/*                    <div className="nk-sales-ck large pt-4">*/}
                {/*                        {dailyWaitTimeException.length > 0 && dailyServiceTimeException.length > 0 ? (*/}
                {/*                            <AudienceLineChart2*/}
                {/*                                waitTimeData={dailyWaitTimeException}*/}
                {/*                                serviceTimeData={dailyServiceTimeException}*/}
                {/*                            />*/}
                {/*                        ) : (*/}
                {/*                            <div style={{textAlign: "center", padding: "2rem", color: "#9eaecf"}}>*/}
                {/*                                No data available*/}
                {/*                            </div>*/}
                {/*                        )}*/}
                {/*                    </div>*/}

                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    /!*<div className="col-md-6 d-flex justify-content-center align-items-center">*!/*/}
                {/*    /!*    <div className="card h-100">*!/*/}
                {/*    /!*        <div className="card-inner">*!/*/}
                {/*    /!*            /!* Second Fragment - Traffic Channel *!/*!/*/}
                {/*    /!*            <div className="card-title-group">*!/*/}
                {/*    /!*                <div className="card-title card-title-sm">*!/*/}
                {/*    /!*                    <h6 className="title">Most Used Services</h6>*!/*/}
                {/*    /!*                </div>*!/*/}
                {/*    /!*            </div>*!/*/}
                {/*    /!*            /!* Conditional rendering based on dailyMostUsedChanel.length *!/*!/*/}
                {/*    /!*            {dailyMostUsedChanel.length > 0 ? (*!/*/}
                {/*    /!*                <div className="traffic-channel">*!/*/}
                {/*    /!*                    <div className="traffic-channel-doughnut-ck">*!/*/}
                {/*    /!*                        <TCDoughnut chartData={dailyMostUsedChanel} className="analytics-doughnut"/>*!/*/}
                {/*    /!*                    </div>*!/*/}
                {/*    /!*                    <div className="traffic-channel-group g-2">*!/*/}
                {/*    /!*                        {trafficStats.map((item, index) => {*!/*/}
                {/*    /!*                            // Define matching colors for each item*!/*/}
                {/*    /!*                            const colors = ["#798bff", "#b8acff", "#ffa9ce", "#f9db7b"];*!/*/}
                {/*    /!*                            return (*!/*/}
                {/*    /!*                                <div key={index} className="traffic-channel-data">*!/*/}
                {/*    /!*                                    <div className="title">*!/*/}
                {/*    /!*                                        <span className="dot dot-lg sq"*!/*/}
                {/*    /!*                                              style={{background: colors[index % colors.length]}}></span>*!/*/}
                {/*    /!*                                        <span>{item.label}</span>*!/*/}
                {/*    /!*                                    </div>*!/*/}
                {/*    /!*                                    <div className="amount">*!/*/}
                {/*    /!*                                        {item.count.toLocaleString()}{" "}*!/*/}
                {/*    /!*                                        <small>{item.percentage}%</small>*!/*/}
                {/*    /!*                                    </div>*!/*/}
                {/*    /!*                                </div>*!/*/}
                {/*    /!*                            );*!/*/}
                {/*    /!*                        })}*!/*/}
                {/*    /!*                    </div>*!/*/}
                {/*    /!*                </div>*!/*/}
                {/*    /!*            ) : (*!/*/}
                {/*    /!*                <div className={"mt-lg-5"}*!/*/}
                {/*    /!*                     style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>*!/*/}
                {/*    /!*                    No data available*!/*/}
                {/*    /!*                </div>*!/*/}
                {/*    /!*            )}*!/*/}
                {/*    /!*        </div>*!/*/}
                {/*    /!*    </div>*!/*/}
                {/*    /!*</div>*!/*/}


                {/*</div>*/}


            </div>

        </>
    );

};

export default AdvanceDashboard;